import { render } from "./VideoPreview.vue?vue&type=template&id=18d88793"
import script from "./VideoPreview.vue?vue&type=script&lang=js"
export * from "./VideoPreview.vue?vue&type=script&lang=js"

import "./VideoPreview.vue?vue&type=style&index=0&id=18d88793&lang=css"

import exportComponent from "/Users/liming/jenkins/jenkins/workspace/an-plus-frontend-monorepo-prod/projects-mobile/property/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__